import request from "@/api/request";
import {buildAsyncRoutes} from '@/utils/routeUtil'
import router from '@/router'
import showToast from "@/utils/toast";

export default {
    namespaced: true,
    state: {
        // 直接存放后端返回原始数组，侧边栏组件直接v‑for渲染，不用处理
        //有权限在展示
        menuList: []
    },
    mutations: {
        loadMenuList(state, value) {
            state.menuList = value;
        },
        clearMenuList(state) {
            state.menuList = [];
        }
    },
    getters: {
        //getter读取了state.menuList
        //当给数组重新赋值：state.menuList = [...newArr] → 触发 getter 重新计算
        //当数组执行 push/splice等可识别数组方法：state.menuList.push(xxx) ,触发重新计算
        getMenuList(state) {
            return [...state.menuList]
                .filter(item => item.visible === 1)
                .map(item => {
                    return {id: item.id, path: item.path, title: item.meta.title, event: item.meta.event,searchbar: item.searchbar};
                })
        }
    },
    actions: {
        //加载权限菜单
        async loadAndRegisterMenus({commit}) {
            // 请求后端接口
            try {
                const response = await request.post("/v1/api/queryMenuList")
                const resp = response.data
                if (resp.responseCode === '0000') {
                    const menuList = resp.data
                    //转换路由对象，循环注册到router，过滤path为空的情况，例如contactMe
                    const asyncRoutes = buildAsyncRoutes(menuList)
                    asyncRoutes.forEach(route => {
                        if (!router.hasRoute(route.name)) {
                            router.addRoute(route.parentName, route)
                        }
                    })
                    if (router.hasRoute('notFound')) {
                        router.removeRoute('notFound')
                    }
                    // 3.全部动态路由注册完成之后，才添加404拦截
                    router.addRoute({
                        path: '/:pathMatch(.*)*',
                        name: 'notFound',
                        component: () => import('@/components/error/NoFound.vue'),
                    })
                    commit('loadMenuList', menuList);
                } else {
                    showToast(resp.responseDesc)
                }
            } catch (e) {
                console.error(e)
                showToast(e.message)
            }
        },
        //退出登陆删除权限菜单
        clearMenuList({commit}) {
            commit('clearMenuList');
        }

    }
}